import React, {useState} from "react";
import {connect} from "react-redux";
import Panel from "../../../../panel/Panel";
import Form from "./forms/DefaultNew";
import {removeAction as removePanelAction} from "../../../../../actions/panel";
import { InsuranceOutlined } from '@ant-design/icons';
import { Button, Result, Spin } from "antd";
import EntityLoader from "../../../../common/EntityLoader";

const Title = ({entity}) => <span>
    <InsuranceOutlined /> {!!entity ? 'Standard-Dienst hinzufügen' : '404 - Not Found'}
</span>;

const Content = connect(
    null,
    dispatch => ({
        onRemovePanel: (uniqueKey) => dispatch(removePanelAction(uniqueKey)),
    })
)(({entity, entityId, onRemovePanel}) => <>
    {entity
        ? <Form groupId={entityId}/>
        : <Result
            status="404"
            title="404"
            subTitle="Sorry, the page you visited does not exist."
            extra={<Button type="primary" onClick={() => onRemovePanel(`cookieconsentsitegroupservices:${entityId}:new:default`)}>close</Button>}
        />
    }
</>);

export default ({groupId}) => {
    const [loading, setLoading] = useState(true);

    return <Panel
        backgroundColor="#882f9c"
        id={`cookieconsentsitegroupservices:${groupId}:new:default`}
        title={
            <EntityLoader entityId={groupId}>
                <Title/>
            </EntityLoader>
        }
    >
        <Spin spinning={loading}>
            <EntityLoader entityId={groupId} onFinally={() => setLoading(false)}>
                <Content/>
            </EntityLoader>
        </Spin>
    </Panel>
};
